import React from 'react';
import SpeakerRow from '../../shared/SpeakerRow';

const MAX = 3;

// Stacked list of an event's published (co-)headliners. Caps at MAX with a
// "+N more" note so cards don't grow unbounded on big panels.
const EventSpeakers = ({ speakers, size = 'md' }) => {
    if (!speakers || !speakers.length) return null;

    const shown = speakers.slice(0, MAX);
    const extra = speakers.length - shown.length;

    return (
        <div className="ev-speakers">
            {shown.map((s, i) => <SpeakerRow key={i} speaker={s} size={size} />)}
            {extra > 0 && <span className="ev-speakers__more">+{extra} more</span>}
        </div>
    );
};

export default EventSpeakers;
